module.exports = __webpack_public_path__ + "static/media/ai-agents-br.90a375dc.png";